import { useState, useEffect } from "react";
import { Box, Typography, Divider, FormGroup, Stack, FormControlLabel, Collapse } from "@mui/material";
import { AutoAwesomeOutlined } from "@mui/icons-material";

import { Switch, Paper, TextField, Autocomplete, TextFieldAutocomplete } from "../../shared";
import { languages } from "../../components/Editor/variables";

export default function AdditionalControl(props: IAdditionalControl) {
    const { onControlChange, onPasswordChange, language, onLanguageChange, control } = { ...props };
    const [passwordControl, setPasswordControl] = useState(false);

    useEffect(() => {
        if (!passwordControl) {
            onPasswordChange(null);
        }
    }, [passwordControl]);

    const handleSwitchChange = (e: any) => {
        onControlChange(e.target.name, e.target.checked);
    };

    return (
        <Box mt={0} mb={0}>
            <Box
                className="side-panel-card"
                sx={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}
            >
                <Box display={"flex"} alignItems={"center"} sx={{ p: 1.5, pl: 2 }} gap={1}>
                    <AutoAwesomeOutlined fontSize={"small"} />
                    <Typography sx={{ fontWeight: 700, fontSize: 14 }}>Options</Typography>
                </Box>
                <Divider sx={{ width: "100%" }} />
                <FormGroup className="w-full">
                    <Stack direction={"column"} gap={0} mt={0.5} alignItems={"flex-start"} p={1} px={2}>
                        <Box className={"w-full"} mb={1}>
                            <Typography
                                gutterBottom
                                sx={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: "var(--fq-primary-text-color)",
                                    opacity: 0.8,
                                }}
                            >
                                Language
                            </Typography>
                            <Autocomplete
                                width={"100%"}
                                disablePortal
                                onChange={(e: any, newValue: any) => onLanguageChange(newValue)}
                                size={"small"}
                                value={language || ""}
                                options={languages}
                                sx={{ width: "100%" }}
                                renderInput={(params: any) => (
                                    <TextFieldAutocomplete {...params} required placeholder="Select language" />
                                )}
                            />
                        </Box>
                    </Stack>
                    <Divider />
                    <Stack direction={"column"} gap={0} mt={0.5} alignItems={"flex-start"} p={1} px={2}>
                        <Box>
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="passwordProtect"
                                        checked={passwordControl}
                                        onChange={(e: any) => setPasswordControl(e.target.checked)}
                                    />
                                }
                                label={
                                    <Typography sx={{ fontSize: 13, color: "var(--fq-primary-text-color)" }}>
                                        Password protect
                                    </Typography>
                                }
                            />
                        </Box>
                        <Collapse in={passwordControl} orientation={"vertical"} sx={{ width: "100%" }}>
                            <Box mt={1} mb={2} width={"100%"}>
                                <TextField
                                    defaultValue={""}
                                    fullWidth
                                    onChange={(e: any) => onPasswordChange(e.target.value)}
                                    label={"Note password"}
                                    sx={{ width: "100%" }}
                                    size="small"
                                />
                            </Box>
                        </Collapse>
                        {extraControls.map((e: any) => {
                            return (
                                <Box key={e.name}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name={e.name}
                                                onChange={handleSwitchChange}
                                                disabled={e.disabled}
                                                checked={control[e.name]}
                                            />
                                        }
                                        label={
                                            <Typography
                                                sx={{
                                                    fontSize: 13,
                                                    color: "var(--fq-primary-text-color)",
                                                    opacity: e.disabled ? 0.65 : 1,
                                                }}
                                            >
                                                {e.label}
                                            </Typography>
                                        }
                                    />
                                </Box>
                            );
                        })}
                        {props.isMobile && (
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="monacoMobile"
                                            onChange={handleSwitchChange}
                                            checked={control.monacoMobile}
                                        />
                                    }
                                    label={
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                color: "var(--fq-primary-text-color)",
                                                fontWeight: 600,
                                            }}
                                        >
                                            Use Monaco Editor
                                        </Typography>
                                    }
                                />
                            </Box>
                        )}
                    </Stack>
                </FormGroup>
            </Box>
        </Box>
    );
}

const extraControls = [
    {
        name: "wrapText",
        label: "Word wrap",
        disabled: false,
    },
    {
        name: "groupNote",
        label: "Group note",
        disabled: true,
    },
    {
        name: "readOnly",
        label: "Read only",
        disabled: true,
    },
];

interface IAdditionalControl {
    onControlChange: any;
    onPasswordChange: any;
    language: any;
    onLanguageChange: any;
    control: any;
    isMobile?: boolean;
}
